module.exports = __webpack_public_path__ + "static/mobile_development-f77dea5ebd64e097d3ba36f5f4ac5db0.svg";